/* eslint-disable global-require, no-underscore-dangle */
import delayedRender from './modules/delayed-render'
import loadPolyfills from './config/polyfills'
import 'what-input'
import './styles/global.css'

/**
 * Initialize the client code.
 */
export default function init() {
  /**
   * Configure the third party tools like Sentry and Analytics
   * Do this now, so we can catch any errors with Sentry
   */

  /**
   * Load any polyfills that's required before rendering.
   */
  return loadPolyfills().then(() => {
    /* We can now render components */
    return renderComponents()
  })
}

function renderComponents() {
  /**
   * If _components exists on the global object, render them out.
   * This will be server side components, that should be rendered once the app is ready.
   */
  if (global._components && Array.isArray(global._components)) {
    return Promise.all(delayedRender(global._components))
      .catch(e => {
        // Error occured while rendering.
        // The delayedRender method has logged the error and rejected the promise. Carry on.
      })
      .then(() => componentsReady())
  }

  return Promise.resolve()
}

function componentsReady() {
  if (process.env.DEV && window.self === window.top) {
    // On dev, disable the server bundle CSS file once the page is rendered.
    // Otherwise, you get duplicate CSS selectors for everything. 😨

    const clearServerCSS = () => {
      document
        .querySelector('head > link[href="/static/css/server.render.css"]')
        .setAttribute('disabled', 'true')
    }

    setTimeout(clearServerCSS, 1000)
  }
}

if (module.hot) {
  /* Support hot reloading the routes */
  module.hot.accept('./modules/delayed-render', () => {
    const newRender = require('./modules/delayed-render').default
    newRender(global._components)
  })
}

/* istanbul ignore next */
if (process.env.NODE_ENV !== 'test') {
  // Init the client now - Moved inside init function to make it testable :)
  init()
}

/* istanbul ignore next */
// if (process.env.NODE_ENV=== 'production') {
//   // Install ServiceWorker in the end since
//   // it's not most important operation and if main code fails,
//   // we do not want it installed
//   if ('serviceWorker' in navigator) {
//     navigator.serviceWorker.register('/static/scripts/sw.js')
//   }
//
//   // ServerWorker causing issues? Need to remove it?
//   // Replace the above register code with the unregister script below.
//   /*
//     if ('serviceWorker' in navigator) {
//       navigator.serviceWorker.getRegistrations().then((registrations) => {
//         registrations.forEach(registration => registration.unregister())
//       })
//     }
//   * */
// }



// WEBPACK FOOTER //
// ./src/client.js